import { useSalesV2GetTermsAndConditions } from '@eneco/dc/hooks/smartthermostat';

export const useOfferTerms = (offerIds?: string[]) => {
  const { send, data } = useSalesV2GetTermsAndConditions();

  function getTermsAndConditions() {
    send({
      offerIds: offerIds ?? [],
    });
  }
  return { termsAndConditions: data?.termsAndConditions, getTermsAndConditions };
};
